import { useEffect, useRef, useState } from "react";
import DRxInput from "../../../uikit/DRxInput";
import IDMELogo from "../../../images/icons/IDme.svg";
import * as yup from "yup";
import { Box } from "@mui/material";
import DigitalRxLogo from "../../../images/icons/DRxLogo.svg";
import { BtnGroupStyle, DRxInputStyle, primaryColor } from "../../../Theme";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { Form, Formik } from "formik";
import { YSButton } from "../../../uikit/YSButton";
import {
  complete2FAEvent,
  saveAsPreferenceApi,
  startMFAEvent,
} from "../../../Apis/Idme2FA";
import { CircularProgress } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setSteps } from "../../../Redux/Slice/IdmeSlice";
type TypesOfData = {
  uuid: string;
  status: string;
  expires: string;
};
export default function CompleteMFAEvent({
  handleHidePopupClick,
  setVerifiedByIdmeUuid,
  setIsBack,
  userUuidData,
}: any) {
  const IdmePreferenceData = useSelector((state: any) => {
    return { ...state.IdmeSlice };
  }); //redux data
  const dispatch = useDispatch();
  const inputRef = useRef<any>({});
  const [seconds, setSeconds] = useState(300);
  const [loading, setLoading] = useState<boolean>(true);
  const [data, setData] = useState<TypesOfData | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [startMfaErrorMessage, setStartMfaErrorMessage] = useState<
    string | null
  >(null);
  const [countOfAttempts, setCountOfAttempts] = useState<number>(1);

  const formatTime = (seconds: number): string => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    if (mins > 0) {
      return `${mins}:${secs}`;
    } else {
      return `${secs}`;
    }
  };
  const handleChange = (event: any, index: any, registerProps: any) => {
    const { value } = event?.target;
    const currentOTP = [...registerProps.values.otp];
    currentOTP[index] = value.slice(-1);
    registerProps.setValues((prev: any) => ({
      ...prev,
      otp: currentOTP,
    }));

    if (value && index < 5) {
      inputRef.current[index + 1]?.focus();
    }
  };
  const handleBackSpace = (event: any, index: any, registerProps: any) => {
    if (event.key === "Backspace") {
      if (index > 0) {
        inputRef.current[index - 1]?.focus();
      }
    }
  };
  const submitPreferenceRoute = async () => {
    try {
      const body = {
        settingType: "MFA_ROUTE",
        enabled: true,
        savedPreference: IdmePreferenceData?.route,
        doctorId: localStorage.getItem("doctorId"),
        userId: localStorage.getItem("LoginUserID"),
      };
      const result = await saveAsPreferenceApi(body);
      if (result?.data?.digitalRxStatusCode === 200) {
        console.log("🚀 ~ submitPreference ~ result?.data:", result?.data);
      }
    } catch (error) {
      console.error("🚀 ~ submitPreference ~ error:", error);
    }
  };
  const submitPreferenceSetup = async () => {
    try {
      const body = {
        settingType: "MFA_SETUP",
        enabled: true,
        savedPreference: IdmePreferenceData?.setup,
        settingIdentifier: IdmePreferenceData?.fetch2FaUuid,
        doctorId: localStorage.getItem("doctorId"),
        userId: localStorage.getItem("LoginUserID"),
      };
      const result = await saveAsPreferenceApi(body);
      if (result?.data?.digitalRxStatusCode === 200) {
        console.log("🚀 ~ submitPreference ~ result?.data:", result?.data);
      }
    } catch (error) {
      console.error("🚀 ~ submitPreferenceSetup ~ error:", error);
    }
  };
  const handleSubmitOTP = async (values: any, resetForm: any) => {
    try {
      setLoading(true);
      setIsBack(false);
      const params: any = new URLSearchParams();
      params.append("code", values.otp.join(""));
      params.append("eventId", data?.uuid);
      params.append("userUUID", localStorage.getItem("userIdmeUuid"));
      params.append(
        "attempts",
        countOfAttempts === 1
          ? "alpha"
          : countOfAttempts === 2
          ? "beta"
          : countOfAttempts === 3
          ? "gamma"
          : null
      );
      const result = await complete2FAEvent(params);
      if (result?.data?.status === "accepted") {
        setLoading(false);
        setErrorMessage(null);
        dispatch(setSteps("success"));
        setTimeout(() => {
          if (
            IdmePreferenceData?.routeEnable === true &&
            IdmePreferenceData?.setupEnable === true &&
            IdmePreferenceData?.route !==
              userUuidData?.savedPreferenceForRoute?.toString() &&
            IdmePreferenceData?.fetch2FaUuid !== userUuidData?.settingIdentifier
          ) {
            Promise.all([
              handleHidePopupClick(),
              submitPreferenceRoute(),
              submitPreferenceSetup(),
              setVerifiedByIdmeUuid(result.data?.uuid),
            ]);
          } else if (
            IdmePreferenceData?.routeEnable === true &&
            IdmePreferenceData?.setupEnable === false &&
            IdmePreferenceData?.route !==
              userUuidData?.savedPreferenceForRoute?.toString()
          ) {
            Promise.all([
              handleHidePopupClick(),
              submitPreferenceRoute(),
              setVerifiedByIdmeUuid(result.data?.uuid),
            ]);
          } else if (
            IdmePreferenceData?.setupEnable === true &&
            IdmePreferenceData?.routeEnable === false &&
            IdmePreferenceData?.fetch2FaUuid !== userUuidData?.settingIdentifier
          ) {
            Promise.all([
              handleHidePopupClick(),
              submitPreferenceSetup(),
              setVerifiedByIdmeUuid(result.data?.uuid),
            ]);
          } else {
            Promise.all([
              handleHidePopupClick(),
              setVerifiedByIdmeUuid(result.data?.uuid),
            ]);
          }
        }, 2000);
      } else {
        const attemptsRemaining = Math.max(0, 3 - countOfAttempts);
        setCountOfAttempts(countOfAttempts + 1);
        setErrorMessage(
          `The provided code is invalid. You have ${attemptsRemaining} attempt${
            attemptsRemaining === 1 ? "" : "s"
          } remaining.`
        );
        setLoading(false);
        if (countOfAttempts > 2) {
          dispatch(setSteps("invalidCode"));
        } else {
          dispatch(setSteps("four"));
        }
      }
    } catch (err: any) {
      dispatch(setSteps("four"));
      setErrorMessage("Something went wrong, please try again!");
      setLoading(false);
    }
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      setSeconds((prev) => {
        if (prev === 0) {
          clearInterval(intervalId);
          dispatch(setSteps("sessionTimeOut"));
          return 0;
        } else {
          return prev - 1;
        }
      });
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    const start2FAEvent = async () => {
      try {
        const params: any = new URLSearchParams();
        params.append("userUUID", localStorage.getItem("userIdmeUuid"));
        params.append("setupId", IdmePreferenceData?.fetch2FaUuid);
        const result = await startMFAEvent(params);
        if (result.status === 200) {
          setData(result?.data);
          setLoading(false);
          setStartMfaErrorMessage(null);
        } else {
          setData(null);
          setLoading(false);
          setStartMfaErrorMessage(result?.data?.message);
        }
      } catch (error: any) {
        setData(null);
        setLoading(false);
        setStartMfaErrorMessage("Something went wrong, please try again!");
      }
    };
    start2FAEvent();
  }, [IdmePreferenceData?.fetch2FaUuid]);

  if (loading) {
    return (
      <>
        <Grid container className="logos" height={384}>
          <Grid item>
            <CircularProgress color="primary" />
          </Grid>
        </Grid>
      </>
    );
  }

  if (startMfaErrorMessage) {
    return (
      <>
        <Grid container className="logos" flexDirection={"column"} height={384}>
          <Grid item>
            <Box className="logos">
              <img src={IDMELogo} alt="ID.me" height={30} />
              <Typography
                component={"div"}
                color={"slategrey"}
                margin={0}
                padding={0}
                variant={"h3"}
                fontWeight={600}
              >
                +
              </Typography>
              <img src={DigitalRxLogo} alt="Digital_Rx" height={30} />
            </Box>
          </Grid>
          <Grid item>
            <Typography variant="h5" color={"error"}>
              {startMfaErrorMessage}
            </Typography>
          </Grid>
        </Grid>
      </>
    );
  }

  return (
    <>
      <Grid container spacing={2} height={400}>
        <Grid item xs={12}>
          <Box className="logos">
            <img src={IDMELogo} alt="ID.me" height={30} />
            <Typography
              component={"div"}
              color={"slategrey"}
              margin={0}
              padding={0}
              variant={"h3"}
              fontWeight={600}
            >
              +
            </Typography>
            <img src={DigitalRxLogo} alt="Digital Rx" height={30} />
          </Box>
        </Grid>
        <Grid item xs={12} textAlign="center">
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <Box className="timer">
                <Typography
                  component={"div"}
                  variant={"h1"}
                  color={seconds === 0 ? "error" : primaryColor}
                >
                  {formatTime(seconds)}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={8}>
              <Grid container spacing={2}>
                <Grid item xs={12} textAlign="left">
                  <Typography
                    component={"div"}
                    variant={"subtitle1"}
                    color={primaryColor}
                    margin={0}
                  >
                    Enter code from your device:{" "}
                    {IdmePreferenceData?.deviceName ?? ""}
                  </Typography>
                </Grid>
                <Grid item xs={12} textAlign="left">
                  <Typography component={"div"} variant={"body2"}>
                    Please check your code generator application like ID.me
                    Authenticator application and enter the generated 6-digit
                    code to complete the sign in.
                  </Typography>
                </Grid>
                <Grid item xs={12} textAlign="left">
                  <Typography
                    component={"div"}
                    variant={"body2"}
                    fontWeight={600}
                  >
                    Enter the 6-digit code:
                  </Typography>
                </Grid>
                <Grid item xs={12} textAlign="left">
                  <Formik
                    initialValues={{ otp: Array.from({ length: 6 }, () => "") }}
                    validationSchema={yup.object().shape({
                      otp: yup
                        .array()
                        .of(
                          yup
                            .string()
                            .required("OTP is required")
                            .length(1, "OTP must be exactly 1 digit")
                        )
                        .min(6, "OTP must be 6 digits")
                        .max(6, "OTP must be 6 digits"),
                    })}
                    enableReinitialize
                    onSubmit={(values, { resetForm }) => {
                      handleSubmitOTP(values, resetForm);
                    }}
                  >
                    {(registerProps) => (
                      <Form onSubmit={registerProps.handleSubmit}>
                        <Box className="OTPinput">
                          <DRxInputStyle className="OTPinput">
                            {registerProps.values.otp.map(
                              (value: any, index: any) => (
                                <DRxInput
                                  key={index}
                                  id={`${index}`}
                                  name={`otp[${index}]`}
                                  type="number"
                                  value={value}
                                  autoFocus={index === 0}
                                  inputRef={(element: any) => {
                                    inputRef.current[index] = element;
                                  }}
                                  onChange={(event: any) =>
                                    handleChange(event, index, registerProps)
                                  }
                                  onKeyUp={(event: any) =>
                                    handleBackSpace(event, index, registerProps)
                                  }
                                />
                              )
                            )}
                          </DRxInputStyle>
                          {errorMessage && (
                            <Typography
                              color="error"
                              variant="body2"
                              marginY={1}
                            >
                              {errorMessage}
                            </Typography>
                          )}
                        </Box>
                        <Grid item xs={12} textAlign="left">
                          <BtnGroupStyle className="left">
                            <YSButton
                              children="Back"
                              variant="outlined"
                              type="button"
                              onClick={() => {
                                dispatch(setSteps("three"));
                                setIsBack(true);
                              }}
                              size="large"
                              className=""
                            />
                            <YSButton
                              children="Continue"
                              variant="contained"
                              type="submit"
                              size="large"
                              className=""
                              disabled={
                                !registerProps.dirty ||
                                !registerProps.isValid ||
                                Object.keys(registerProps.errors).length > 0
                                  ? true
                                  : false
                              }
                            />
                          </BtnGroupStyle>
                        </Grid>
                      </Form>
                    )}
                  </Formik>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
